import { render } from "./SFTemplateManage.vue?vue&type=template&id=488ae166&scoped=true"
import script from "./SFTemplateManage.vue?vue&type=script&lang=js"
export * from "./SFTemplateManage.vue?vue&type=script&lang=js"

import "./SFTemplateManage.vue?vue&type=style&index=0&id=488ae166&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-488ae166"

export default script